import { appLog } from '../appLog';

/**
 * RSVP-to-map timings (2026-10-13 audit): how long a map takes to read from the phone, download, and build, measured on
 * phones (app_logs, native only) instead of guessed. Printed to the console in dev.
 */
export const mapNow = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

export function mapTiming(eventName, payload) {
  const row = { ...payload, ms: Math.round(payload.ms) };
  if (import.meta.env.DEV) console.info('[map-timing]', eventName, row);
  appLog('info', eventName, row);
}
